import { Box, VStack, StackProps } from '@chakra-ui/react';
import React from 'react';

export interface DashboardLayoutActionsProps extends Pick<StackProps, 'p'> {}

export const DashboardLayoutActions: React.FC<DashboardLayoutActionsProps> = (props) => (
    <Box p={props.p}>{props.children}</Box>
);
